export default __webpack_public_path__ + "static/media/punti-vendita-dark.394745e9.svg";